<template>
    <div class="users">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>报修列表</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="margin-top: 1rem; padding: 1.5rem 1rem 0 1rem; background-color: white">
            <el-form :inline="true" :model="query">
                <el-form-item label="产品序列号:">
                    <el-input v-model="query.deviceNo" placeholder="产品序列号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onQuery">查询</el-button>
                    <el-button type="default" @click="query = {}">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="margin-top: 1rem; padding: 1rem; background-color: white">
            <el-table
                    :data="reports"
                    border
                    stripe
                    v-loading="loading"
                    style="width: 100%">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <img :src="e" alt="" v-for="e in props.row.pics.split(',')" style="width: 100px;">
                    </template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="deviceNo"
                        label="产品序列号">
                </el-table-column>
                <el-table-column
                        sortable
                        :sort-method="(a, b) => a.contact ? a.contact.localeCompare(b.contact, 'zh') : -1"
                        prop="contact"
                        label="联系人">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="contactTel"
                        label="联系人电话">
                </el-table-column>
                <el-table-column
                        sortable
                        :sort-method="(a, b) => a.deviceAddress ? a.deviceAddress.localeCompare(b.deviceAddress, 'zh') : -1"
                        prop="deviceAddress"
                        label="设备地址">
                </el-table-column>
                <el-table-column
                        sortable
                        :sort-method="(a, b) => a.deviceQuestion ? a.deviceQuestion.localeCompare(b.deviceQuestion, 'zh') : -1"
                        prop="deviceQuestion"
                        label="设备问题">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="createTime"
                        label="报修时间">
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click="deleteReport(scope.row.id)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="text-align: center">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pagination.page"
                        :page-sizes="[10, 20, 50, 100, 200]"
                        :page-size="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import reportApi from "../../api/report";
    export default {
        data: function () {
            return {
                reports: [],
                loading: false,
                total: 0,
                pagination: {
                    page: sessionStorage.getItem("page") || 1,
                    pageSize: 10
                },
                query: {

                },
            }
        },
        mounted() {
            this.loadUsers();
        },
        methods: {
            loadUsers: function () {
                this.loading = true;
                reportApi.getAll(this.query, this.pagination).then(result => {
                    this.loading = false;
                    this.reports = result.data;
                    this.total = result.total;
                })
            },
            onQuery: function () {
                this.pagination = {
                    page: 1,
                    pageSize: 10
                }
                this.loadUsers();
            },
            handleSizeChange: function (size) {
                this.pagination = {
                    page: 1,
                    pageSize: size
                }
                this.loadUsers();
            },
            handleCurrentChange: function (page) {
                sessionStorage.setItem("page", page);
                this.pagination = {
                    ...this.pagination,
                    page: page,
                }
                this.loadUsers();
            },
            deleteReport: function (id) {
                this.$confirm('确定删除该报修？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    reportApi.deleteById(id).then(result => {
                        this.loading = false;
                        this.loadUsers();
                    })
                });
            }
        }
    }
</script>
